import React, {Component} from 'react';
import moment from 'moment';

class QuestionTimer extends Component {
    constructor(props){
        super(props);

        this.state = {
            time: 0
        }
        this.timer = null;
    }

    updateTimer = () => {
        this.setState({time: this.state.time + 1});

    }

    componentDidMount(){
        if(!this.timer && this.props.start){
            this.timer = setInterval(this.updateTimer, 1000);
            this.setState({userTime: this.props.start, testTime: this.props.testTime});
        }
    }

    componentDidUpdate(props){
        if(!this.timer && this.props.start){
            this.timer = setInterval(this.updateTimer, 1000);
            this.setState({userTime: this.props.start, testTime: this.props.testTime});
        }

        if(props.start && !this.props.start && this.timer){
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    reset = () => {
        this.setState({time: 0});
    }

    render(){
        return (
            null
        )
    }
}

export default QuestionTimer;


// WEBPACK FOOTER //
// ./src/components/UserCourse/QuestionTimer.js